//@ts-check

/** @typedef {import("./GameList.js").GameListType} GameListType */
/** @type {GameListType} */
let GameList;
const BRAND_NAME = process.env.BRAND_NAME;

if (BRAND_NAME === "yalla") {
    // @ts-ignore
    GameList = (await import("./GameListYalla.js")).GameList;
} else {
    // @ts-ignore
    GameList = (await import("./GameListBeeFee.js")).GameList;
}

export { GameList };